import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { xl: "12", lg: "12", md: "12", sm: "12", xs: "12" } },
            [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { sm: "12", lg: "12" } },
                    [
                      _c(VDataTable, {
                        staticClass: "table-inca",
                        attrs: {
                          "hide-default-footer":
                            Object.keys(_vm.item.pages).length <= 10
                              ? true
                              : false,
                          dense: "",
                          items: _vm.item.pages,
                          headers: [
                            { value: "index", text: "N°" },
                            {
                              value: "name",
                              text: _vm.$t("my_tasks.tablas_tasks.name"),
                            },
                          ],
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.index",
                            fn: function (ref) {
                              var index = ref.index
                              return [_vm._v(_vm._s(index + 1))]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }